const Index = () => import("./index");
const MonthlyTaxes = () => import("./MonthlyTaxes.vue");

export default [{
  path: "monthlyTaxes",
  name: "monthlyTaxes-report",
  component: Index,
  redirect: {
    name: "monthlyTaxes",
  },
  children: [{
    path: "date",
    name: "monthlyTaxes",
    component: MonthlyTaxes,
  }],
},
]
